// extracted by mini-css-extract-plugin
export default {"main":"Divider_main__24yrS","textNoHR":"Divider_textNoHR__8luOm","text":"Divider_text__PhU6N","icon":"Divider_icon__Em01n","hr":"Divider_hr__ZEV6f"};